export default {
    'create-financial-file': 'Create financial file',
    'create-backup': 'Create backup',
    'edit-financial-file': 'Edit financial file',
    'backups-management': "Backups Management",
    'delete-old-backups': "Delete Old Backups",
    'old-backups-delete-alert': "All backups created more than 7 days ago will be deleted",
    'close': "Close",
    currency: 'Currency',
    "configure-financial-file": "Configure financial file",
    "financial-file-created-successfully": "financial file has been created successfully !",
    "configure-your-financial-file": "Would you like to configure your financial file now?",
    "create-default-warehouse": "Create default warehouse",
    "default-warehouse": "Default warehouse",
    "create-accounting-tree": "Create accounting tree",
    "do-you-want-to-create-a-default-accounting-tree": "Would you like to create a default accounting tree? (It is recommended)",
    "configure": "Configure",
    "created-and-configured-successfully": "The financial file has been created and configured successfully !",
    "go-to-settings": "Would you like to customize some settings for your financial file? Click here to go to the settings page",
    save: 'Save',
    cancel: 'Cancel',

    confirm: 'Confirm',
    'browse-content': 'View content',

    'do-you-want-to-change-the-current-financial-file': 'Do you want to change the current financial file',

    'rotated-to-$': 'Revolved to "{financialFile}"',
    rotated: 'Revolved',
    locked: 'Closed',
    unlocked: 'Unclosed',

    'the-users-of-the-file-$-and-their-permissions': '{financialFile} file users and their permissions',

    permissions: {
        title: 'permissions',
        'no-permissions': 'No permissions',
        viewer: 'Read-only permission',
        accountant: 'Accountant',
        'warehouse-keeper': 'Warehouse keeper',
        'warehouse-manager': 'Warehouse manager'
    },

    'the-logo-is-uploaded-successfully': 'The logo is uploaded successfully'
}